import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { CareServiceReportOrgansStructure } from '@/api';
import { useIsQualityReviewApplicable } from '@/shared/hook';
import { Loading } from '@/shared/ui';
import { generateAppRoute } from '@/shared/util';

import { CarePlanServiceProvider } from './care-plan-service.provider';
import {
  generateOrganLinks,
  hasOnlyBodyCompositionService,
  parseCarePlanToOrgans,
} from './care-plan-service.util';
import { useCareServiceReportOrgans } from './use-care-plan-service-organs.hook';

interface CarePlanServiceGuardProps {
  children: ReactNode;
}

export function CarePlanServiceGuard({ children }: CarePlanServiceGuardProps) {
  const isQualityReviewApplicable = useIsQualityReviewApplicable();

  const { data, isLoading } = useCareServiceReportOrgans();

  if (isLoading) {
    return <Loading />;
  }

  if (!data) {
    return <Navigate replace to={generateAppRoute('NOT_FOUND')} />;
  }

  const { carePlanServices = [] } = data;

  const { structure } = parseCarePlanToOrgans(data as CareServiceReportOrgansStructure);

  const links = generateOrganLinks({
    isBodyComposition: hasOnlyBodyCompositionService(carePlanServices),
    isQualityReviewApplicable,
    structure,
  });

  return <CarePlanServiceProvider links={links}>{children}</CarePlanServiceProvider>;
}
